import {NavLink} from "react-router-dom";

const Index = (props) => {


    return (

        <section className="pb-20 pt-20 position-relative">
            <div className="container-xxl">

                <div className="card border shadow-none">
                    <div className="card-body p-0">
                        <div className="table-responsive">
                            <table className="table table-hover table-nowrap">
                                <thead className="thead-light shuffle-sizer">
                                <tr>
                                    <th scope="col">ارز</th>
                                    <th scope="col">قیمت فروش <span className="text-muted text-sm"> (تومان) </span></th>
                                    <th scope="col">قیمت خرید <span className="text-muted text-sm"> (تومان) </span></th>


                                    <th></th>
                                </tr>
                                </thead>
                                <tbody id="shuffle-container">


                                {props.trs && props.trs.map(function (c, i) {

                                    return (

                                        <tr key={'sddfdfdf'+i} className="shuffle-selector">
                                            <td>
                                                <img src={c.logo} alt={c.alt}
                                                     data-toggle="tooltip" data-placement="top" title={c.name}
                                                     className="avatar avatar-sm ms-1"/> <NavLink
                                                onClick={()=>{

                                                    props.setTraid(c.en)
                                                }}
                                                className="text-heading font-bold"
                                                to={window.config.staticAddress + "/trades/" + c.en + ""}> {c.name} </NavLink>
                                                <span
                                                    className="badge rounded bg-light border text-muted en coin-symbol-pos"> {c.en} </span>
                                            </td>
                                            <td className="text-end text-heading" dir="ltr" id="BTC-sell"><span
                                                className="en font-bold">
                                          {parseFloat(c.sell).toLocaleString()}
                                       </span></td>
                                            <td className="text-end text-heading" dir="ltr" id="BTC-buy"><span
                                                className="en font-bold">
                                              {parseFloat(c.buy).toLocaleString()}
                                      </span></td>


                                            <td className="text-start"  onClick={()=>{

                                                props.setTraid(c.en)
                                            }} ><NavLink
                                                className="btn btn-sm btn-success text-nowrap shadow-none"
                                                to={window.config.staticAddress + "/trades/" + c.en + ""}> <i
                                                className="far fa-exchange ms-1 opacity-50"></i> خرید
                                                و فروش </NavLink></td>
                                        </tr>


                                    )
                                })}


                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>)
}
export default Index;
